export interface IBank {
  id?: number;
  bankCode?: string;
  displayName?: string;
  logo?: string | null;
  accountNumber?: string | null;
  accountName?: string | null;
  isActive?: boolean | null;
  autoBankingMethod?: string | null;
  oauthEmail?: string | null;
  oauthClientId?: string | null;
}

export const defaultValue: Readonly<IBank> = {
  isActive: false,
};
